module.exports = __webpack_public_path__ + "static/media/gray-location.849e9f26.svg";